const gradient_props = {
  red: {
    time: 324,
    seed: 57,
    colors: {
      light: ["#ed0000", "#f8681e", "#fda056", "#ffce95"],
      dark: ["#ff9a9a", "#ffae9a", "#ffc1a1", "#ffd4b0"],
    },
  },
  green: {
    time: 1137,
    seed: 32,
    colors: {
      light: ["#00eced", "#2af6d6", "#61fcb8", "#95ff95"],
      dark: ["#00b2b6", "#00b89f", "#00ba7b", "#45b845"],
    },
  },
  neon_green: {
    time: 420,
    seed: 161,
    colors: {
      light: ["#4FFF00", "#98fe23", "#c3fe47", "#E2FF6A"],
      dark: ["#208a18", "#54a425", "#7fbe33", "#a8d943"],
    },
  },
  blue: {
    time: 320,
    seed: 73,
    colors: {
      light: ["#0f0fff", "#007feb", "#00b5fe", "#6ae2ff"],
      dark: ["#d4d8ff", "#c0dfff", "#a7e8ff", "#90f1ff"],
    },
  },
};

export default gradient_props;
